import SuppliersScreen from './SuppliersScreen'
export default SuppliersScreen
